// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-img-single[data-v-78ab90cc]{margin-bottom:8px;width:240px;height:160px;background:#fff;border-radius:4px;border:1px solid #ddd;position:relative}.video-img-single.is-dragging[data-v-78ab90cc]{border:1px dashed #ddd}.video-img-single[data-v-78ab90cc]  .el-image{display:block;height:100%}.video-img-single[data-v-78ab90cc]  .el-image img,.video-img-single>img[data-v-78ab90cc]{width:100%;height:100%;border-radius:4px}", ""]);
// Exports
module.exports = exports;
